<samweb-action
   [brickInstanceId]="brickInstanceId"
   [toolbarId]="'toolbar'"
   [isVerticalViewPossible]="true"
></samweb-action>
